/*
 *
 * LanguageProvider constants
 *
 */

export const CHANGE_LOCALE = 'app/LanguageToggle/CHANGE_LOCALE';
export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';
export const CHANGE_LANGUAGE_REQUEST = 'CHANGE_LANGUAGE_REQUEST';
export const LANGUAGE_SELECT_MODAL = 'LANGUAGE_SELECT_MODAL';
export const LANGUAGE_UPDATE_FAILURE = 'LANGUAGE_UPDATE_FAILURE';
